import { forwardRef, Icon, IconProps } from "@chakra-ui/react";
export default forwardRef<IconProps, "svg">((props, svgRef) => (
  <Icon
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 20 4"
    ref={svgRef}
    {...props}
  >
    <circle
      cx={18}
      cy={2}
      r={2}
      fill="currentColor"
      transform="rotate(90 18 2)"
    />
    <circle
      cx={10}
      cy={2}
      r={2}
      fill="currentColor"
      transform="rotate(90 10 2)"
    />
    <circle
      cx={2}
      cy={2}
      r={2}
      fill="currentColor"
      transform="rotate(90 2 2)"
    />
  </Icon>
));
